var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%","width":"100%"}},[(_vm.isLoaded && _vm.focusedClient)?_c('div',{staticStyle:{"height":"100%","position":"relative"}},[_c('ClientRecordEntries')],1):_vm._e(),(!_vm.isLoaded && _vm.focusedClient)?_c('div',{staticStyle:{"height":"100%"}},[_c('DiarySkeleton',{attrs:{"type":"record"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }